import { Component } from '@angular/core';

@Component({
  moduleId: module.id,
  templateUrl: 'not-found.component.html',
  providers: []
})
export class NotFoundComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/components/common/not-found.component.ts